// Auto-generated by tools/avatar/generate-clothing-svgs.mjs
 
import type { RecordOfClothingComponents } from './types'

import BlazerShirtSvg from './blazer-shirt.svg?raw'
import BlazerSweaterSvg from './blazer-sweater.svg?raw'
import CollarSweaterSvg from './collar-sweater.svg?raw'
import GraphicShirtSvg from './graphic-shirt.svg?raw'
import HoodieSvg from './hoodie.svg?raw'
import OverallSvg from './overall.svg?raw'
import ShirtCrewNeckSvg from './shirt-crew-neck.svg?raw'
import ShirtScoopNeckSvg from './shirt-scoop-neck.svg?raw'
import ShirtVNeckSvg from './shirt-vneck.svg?raw'

export const clothingComponents = {
  BlazerShirt: BlazerShirtSvg,
  BlazerSweater: BlazerSweaterSvg,
  CollarSweater: CollarSweaterSvg,
  GraphicShirt: GraphicShirtSvg,
  Hoodie: HoodieSvg,
  Overall: OverallSvg,
  ShirtCrewNeck: ShirtCrewNeckSvg,
  ShirtScoopNeck: ShirtScoopNeckSvg,
  ShirtVNeck: ShirtVNeckSvg,
} satisfies RecordOfClothingComponents

export type ClothingComponentName = keyof typeof clothingComponents
